export const flow = [
  {
    title: "Upload Your Transcripts , Max 5 at a time",
    img: "/tg-steps/step-4.png",
    description:
      "Simply drag and drop your PDF transcripts from any supported country onto our secure platform.",
  },
  {
    title: "AI-Powered Analysis",
    img: "/tg-steps/step-2.png",
    description:
      "Our AI algorithms analyze and interpret the grading scales, courses, and academic performance detailed in your transcript.",
  },
  {
    title: "Automatic Conversion",
    img: "/tg-steps/step-6.png",
    description:
      "Transcript Genie automatically converts your international grades to the U.S. grading system, ensuring accuracy and consistency.",
  },
  {
    title: "Review and Download",
    img: "/tg-steps/step-9.png",
    description:
      "Review the converted transcript for accuracy and download your U.S.-standardized academic credentials in seconds.",
  },
];
